export type TIconNames =
  | "icontext"
  | "webcom-logo-short"
  | "webcom-logo-with-bg"
  | "webcom-logo"
  | "phone-old"
  | "sms-old"
  | "clock-old"
  | "checked-old"
  | "bell-old"
  | "person-old"
  | "play-old"
  | "settings-old"
  | "signout-old"
  | "envelope-old"
  | "info-old"
  | "location-old"
  | "crm-old"
  | "cart-old"
  | "dollar-old"
  | "book-old"
  | "burger-old"
  | "show"
  | "cross"
  | "calendar-today"
  | "check-circle"
  | "info"
  | "warning"
  | "close"
  | "search"
  | "more-Horiz"
  | "chevron-right"
  | "chevron-left"
  | "tune"
  | "add"
  | "mop"
  | "north"
  | "south"
  | "sort-desc"
  | "sort-asc"
  | "sort-unsorted"
  | "note"
  | "plus-button"
  | "cross-button"
  | "download"
  | "mailru"
  | "fb"
  | "google_ads"
  | "snapchat"
  | "twitter"
  | "vk"
  | "yandex"
  | "linkedin"
  | "telegram"
  | "tiktok"
  | "mailbox"
  | "support"
  | "clients"
  | "crm"
  | "sales"
  | "finances"
  | "academy"
  | "protext"
  | "seo"
  | "dev"
  | "context"
  | "communication"
  | "marketing"
  | "password"
  | "calendar"
  | "task"
  | "staff"
  | "tools"
  | "roombook"
  | "report"
  | "postoffice"
  | "documents"
  | "commission"
  | "two-person"
  | "adgen"
  | "adflow"
  | "sentinel"
  | "electron-icon"
  | "google_ads_st"
  | "meta_st"
  | "tiktok_st"
  | "yandex_direct_st"
  | "vk_ads_st"
  | "ybusiness"
  | "ynavigator"
  | "google_ads_transactions"
  | "yandex_direct_transactions"
  | "tiktok_transactions"
  | "meta_transactions"
  | "telegram_transactions"
  | "vk_ads_transactions"
  | "empty_wallet_transactions";
export enum EIconNames {
  ICONTEXT = "icontext",
  WEBCOM_LOGO_SHORT = "webcom-logo-short",
  WEBCOM_LOGO_WITH_BG = "webcom-logo-with-bg",
  WEBCOM_LOGO = "webcom-logo",
  PHONE_OLD = "phone-old",
  SMS_OLD = "sms-old",
  CLOCK_OLD = "clock-old",
  CHECKED_OLD = "checked-old",
  BELL_OLD = "bell-old",
  PERSON_OLD = "person-old",
  PLAY_OLD = "play-old",
  SETTINGS_OLD = "settings-old",
  SIGNOUT_OLD = "signout-old",
  ENVELOPE_OLD = "envelope-old",
  INFO_OLD = "info-old",
  LOCATION_OLD = "location-old",
  CRM_OLD = "crm-old",
  CART_OLD = "cart-old",
  DOLLAR_OLD = "dollar-old",
  BOOK_OLD = "book-old",
  BURGER_OLD = "burger-old",
  SHOW = "show",
  CROSS = "cross",
  CALENDAR_TODAY = "calendar-today",
  CHECK_CIRCLE = "check-circle",
  INFO = "info",
  WARNING = "warning",
  CLOSE = "close",
  SEARCH = "search",
  MORE_HORIZ = "more-Horiz",
  CHEVRON_RIGHT = "chevron-right",
  CHEVRON_LEFT = "chevron-left",
  TUNE = "tune",
  ADD = "add",
  MOP = "mop",
  NORTH = "north",
  SOUTH = "south",
  SORT_DESC = "sort-desc",
  SORT_ASC = "sort-asc",
  SORT_UNSORTED = "sort-unsorted",
  NOTE = "note",
  PLUS_BUTTON = "plus-button",
  CROSS_BUTTON = "cross-button",
  DOWNLOAD = "download",
  MAILRU = "mailru",
  FB = "fb",
  GOOGLE_ADS = "google_ads",
  SNAPCHAT = "snapchat",
  TWITTER = "twitter",
  VK = "vk",
  YANDEX = "yandex",
  LINKEDIN = "linkedin",
  TELEGRAM = "telegram",
  TIKTOK = "tiktok",
  MAILBOX = "mailbox",
  SUPPORT = "support",
  CLIENTS = "clients",
  CRM = "crm",
  SALES = "sales",
  FINANCES = "finances",
  ACADEMY = "academy",
  PROTEXT = "protext",
  SEO = "seo",
  DEV = "dev",
  CONTEXT = "context",
  COMMUNICATION = "communication",
  MARKETING = "marketing",
  PASSWORD = "password",
  CALENDAR = "calendar",
  TASK = "task",
  STAFF = "staff",
  TOOLS = "tools",
  ROOMBOOK = "roombook",
  REPORT = "report",
  POSTOFFICE = "postoffice",
  DOCUMENTS = "documents",
  COMMISSION = "commission",
  TWO_PERSON = "two-person",
  ADGEN = "adgen",
  ADFLOW = "adflow",
  SENTINEL = "sentinel",
  ELECTRON_ICON = "electron-icon",
  GOOGLE_ADS_ST = "google_ads_st",
  META_ST = "meta_st",
  TIKTOK_ST = "tiktok_st",
  YANDEX_DIRECT_ST = "yandex_direct_st",
  VK_ADS_ST = "vk_ads_st",
  YBUSINESS = "ybusiness",
  YNAVIGATOR = "ynavigator",
  GOOGLE_ADS_TRANSACTIONS = "google_ads_transactions",
  YANDEX_DIRECT_TRANSACTIONS = "yandex_direct_transactions",
  TIKTOK_TRANSACTIONS = "tiktok_transactions",
  META_TRANSACTIONS = "meta_transactions",
  TELEGRAM_TRANSACTIONS = "telegram_transactions",
  VK_ADS_TRANSACTIONS = "vk_ads_transactions",
  EMPTY_WALLET_TRANSACTIONS = "empty_wallet_transactions",
}
